<template>
    <v-container grid-list-xl>
        <v-layout my-6>
            <v-btn @click="$router.go(-1)" class="my-auto">
                <v-icon>navigate_before</v-icon>
                {{ $t('back') }}
            </v-btn>

            <v-flex ml-12 xs10>
                <div class="display-3 font-weight-thin">{{ $i18n.t('subjects') }}</div>
            </v-flex>

            <v-spacer/>

            <v-btn @click="createSubject" class="my-auto mx-4" color="teal">
                {{ $t('addSubject') }}
                <v-icon right>add</v-icon>
            </v-btn>
        </v-layout>

        <v-card>
            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="getSubjects"
                    :items-per-page="15"
                    :loading="isLoading"
                    :loading-text="$i18n.t('loading')"
                    :no-results-text="$t('noResults')"
                    :no-data-text="$t('noData')">

                    <template v-slot:item.teachers="subjectItem">
						<v-overflow-btn
							:items="getUsers"
                            v-model="getTeachingsBySubject[subjectItem.item.id]"
                            item-value="id"
							multiple
							dense
							class="mt-3 mb-n3">

                            <template v-slot:selection="{ index }">
                                {{ index == getTeachingsBySubject[subjectItem.item.id].length-1 ? index+1 + " " + (index == 0 ? $t('teacherSelected') : $t('teachersSelected')) : "" }}
                            </template>

                            <template v-slot:item="userItem">
                                <v-checkbox
                                    v-model="userItem.attrs.inputValue"
                                    :label="userItem.item.fullName"
                                    @change="$store.dispatch('updateTeaching', {userId: userItem.item.id, subjectId: subjectItem.item.id, value: userItem.attrs.inputValue})"
                                    :disabled="isLoading"/>
                            </template>
                        </v-overflow-btn>
                            
                    </template>
                </v-data-table>
            </v-card-text>

            <v-dialog v-model="createSubjectDialog" max-width="1300px">
                <CreateSubject/>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import CreateSubject from '@/components/Subject/CreateSubject'

export default {
    methods: {
        createSubject(){
            this.$store.dispatch('getTitles')
            this.$store.commit('newSubject')
            this.$store.commit('setCreateSubjectDialog', true)
        },
    },

    created(){
        this.$store.dispatch('getUsers')
        this.$store.dispatch('getSubjects')
        this.$store.dispatch('getTeachingsBySubject')
    },

    computed: {
        ...mapGetters([
            'isLoading',
            'getUsers',
            'getSubjects',
            'getTeachingsBySubject',
            'getCreateSubjectDialog',
        ]),
        headers() { 
            return[
                { text: "ID", value: 'id', align: 'left', width: "10px"},
                { text: this.$t('name'), value: 'name', align: 'left' },
                { text: this.$t('code'), value: 'code', align: 'left' },
                { text: this.$t('teachers'), value: 'teachers', align: 'center', sortable: false, width: "300px"},
            ]
        },
        createSubjectDialog: {
            get() { return this.getCreateSubjectDialog },
            set(value) { this.$store.commit('setCreateSubjectDialog', value) },
        },
    },

    components: {
        CreateSubject,
    },
}
</script>
